function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { translate } from '../../utils/helpers';
import FormErrors from '../FormErrors';
import PropTypes from 'prop-types';
import Form from '../../utils/Form';
import { LANG, API_URL, DEFAULT_LANG } from '../../utils/constant';
/* eslint-disable */

var AskInformationsPage = /*#__PURE__*/function (_Component) {
  _inherits(AskInformationsPage, _Component);

  var _super = _createSuper(AskInformationsPage);

  function AskInformationsPage(props) {
    var _this;

    _classCallCheck(this, AskInformationsPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validateForm", function () {
      _this.setState({
        formValid: _this.state.fields.filter(function (field) {
          return field.valid === false;
        }).length === 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFields", function (fields) {
      var shouldValidateForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        fields: fields
      }, function () {
        if (shouldValidateForm) {
          _this.validateForm();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setCheckboxes", function (checkboxes) {
      _this.setState({
        checkboxes: checkboxes
      });
    });

    _defineProperty(_assertThisInitialized(_this), "boolToString", function (val) {
      if (val) return '1';else return '0';
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      if (_this.askInformation.current.isFormValid()) {
        _this.createPost();

        _this.setState({
          isSubmitted: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSiteName", function () {
      return document.querySelector('#SITE_NAME').value;
    });

    _defineProperty(_assertThisInitialized(_this), "createPost", function () {
      var info = {
        firstName: _this.state.fields[0].value,
        lastName: _this.state.fields[1].value,
        email: _this.state.fields[2].value,
        company: _this.state.fields[3].value,
        phone: _this.state.fields[4].value,
        city: _this.state.fields[5].value,
        secteur: _this.state.fields[6].value,
        client_ino: _this.state.fields[7].value,
        info: document.getElementById('textarea-info').value,
        searchEngine: _this.boolToString(_this.state.checkboxes[0].value),
        printedAdvertising: _this.boolToString(_this.state.checkboxes[1].value),
        advertisingInStore: _this.boolToString(_this.state.checkboxes[2].value),
        referencedWebsite: _this.boolToString(_this.state.checkboxes[3].value),
        recommandation: _this.boolToString(_this.state.checkboxes[4].value),
        productTesting: _this.boolToString(_this.state.checkboxes[5].value),
        newsletter: _this.boolToString(_this.state.checkboxes[7].value),
        other: _this.state.checkboxes[6].value,
        sendTo: _this.getAskInformationEmail(),
        defaultLang: DEFAULT_LANG,
        lang: LANG,
        websiteEmail: _this.getWebsiteEmail()
      };
      var url = API_URL + '/ask_info';
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(info)
      }).then(function (res) {
        if (res.status === 204) return '';
        return res.json();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAskInformationEmail", function () {
      return document.querySelector('body').getAttribute('ask-informations');
    });

    _defineProperty(_assertThisInitialized(_this), "getWebsiteEmail", function () {
      var websiteEmail = document.querySelector('body').getAttribute('ask-informations');
      return websiteEmail !== '' ? 'website@' + websiteEmail.split('@')[1] : 'siteweb@sani-depot.ca';
    });

    _defineProperty(_assertThisInitialized(_this), "getMessageIcon", function () {
      return document.querySelector('body').getAttribute('message-sent');
    });

    _this.askInformation = /*#__PURE__*/React.createRef();
    _this.state = {
      email: {},
      fields: [{
        name: 'firstName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('First name', 'Prénom'),
        type: 'text',
        value: ''
      }, {
        name: 'lastName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Lastname', 'Nom'),
        type: 'text',
        value: ''
      }, {
        name: 'email',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Email', 'Courriel'),
        type: 'email',
        value: ''
      }, {
        name: 'company',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Company', 'Entreprise'),
        type: 'text',
        value: ''
      }, {
        name: 'phone',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Phone', 'Téléphone'),
        type: 'text',
        value: ''
      }, {
        name: 'city',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('City', 'Ville'),
        type: 'text',
        value: ''
      }, {
        name: 'client_ino',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('ALREADY AN INO SOLUTIONS CLIENT?', "DÉJÀ CLIENT INO SOLUTIONS ?"),
        type: 'text',
        value: ''
      }, {
        name: 'secteur',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Field of activity', "Secteur d'activité"),
        type: 'text',
        value: ''
      }],
      checkboxes: [{
        name: 'search-engine',
        error: '',
        placeholder: translate('Search Engine', 'Moteur de recherche'),
        type: 'checkbox',
        value: false
      }, {
        name: 'printed-advertising',
        error: '',
        placeholder: translate('Printed advertising', 'Publicité imprimée'),
        type: 'checkbox',
        value: false
      }, {
        name: 'advertising-store',
        error: '',
        placeholder: translate('Advertising in store', 'Publicité de magasin'),
        type: 'checkbox',
        value: false
      }, {
        name: 'referenced-website',
        error: '',
        placeholder: translate('Referenced website', 'Site de référence'),
        type: 'checkbox',
        value: false
      }, {
        name: 'recommandation',
        error: '',
        placeholder: translate('Recommandation', 'Recommandation'),
        type: 'checkbox',
        value: false
      }, {
        name: 'product-testing',
        error: '',
        placeholder: translate('Product testing', 'Test de produit'),
        type: 'checkbox',
        value: false
      }, {
        name: 'other',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Other', 'Autre'),
        type: 'text',
        value: ''
      }, {
        name: 'receive-info',
        error: '',
        placeholder: translate("Yes, I would like to receive informations regarding ".concat(_this.getSiteName()), "Oui, je d\xE9sire recevoir des informations et nouveaut\xE9s relatives \xE0 ".concat(_this.getSiteName())),
        type: 'checkbox',
        value: false
      }],
      formValid: false,
      boxValid: false,
      isSubmitted: false
    };
    return _this;
  }

  _createClass(AskInformationsPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.state.isSubmitted ? /*#__PURE__*/React.createElement("div", {
        className: "container mt-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 submitted"
      }, /*#__PURE__*/React.createElement("span", null, translate('MESSAGE SENT', 'MESSAGE ENVOYÉ')), /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.getMessageIcon(),
        alt: ""
      })), /*#__PURE__*/React.createElement("a", {
        href: "/#"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark"
      }, translate('RETURN TO HOME PAGE', "RETOUR À L'ACCUEIL"))))) : /*#__PURE__*/React.createElement("div", {
        className: "ask-informations-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container "
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mobile-center main-bg-after"
      }, translate('Contact us ', "Demande d'informations")), /*#__PURE__*/React.createElement("p", {
        className: "col-lg-8 col-md-12"
      }, translate('Send us your questions, comments or any other information request. A representative will take time to give you support.', 'N’hésitez pas à nous transmettre vos questions, commentaires ou toutes autres demandes d’information. Soyez assurés qu’un préposé prendra le soin de vous répondre dans les meilleurs délais.')))), /*#__PURE__*/React.createElement("div", {
        className: "row informations "
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left-ask-information col-lg-6 col-md-12 "
      }, /*#__PURE__*/React.createElement(Form, {
        id: "body",
        fields: this.state.fields,
        ref: this.askInformation,
        setParentState: function setParentState(fields, shouldValidateForm) {
          return _this2.setFields(fields, shouldValidateForm);
        }
      }), /*#__PURE__*/React.createElement(FormErrors, {
        fields: this.state.fields.filter(function (field) {
          return field.error !== '';
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "right col-lg-6 col-md-12 "
      }, /*#__PURE__*/React.createElement("textarea", {
        className: "textarea",
        rows: "5",
        placeholder: "INFORMATIONS",
        id: "textarea-info"
      }), /*#__PURE__*/React.createElement("div", {
        className: "heard-about"
      }, /*#__PURE__*/React.createElement("span", null, translate("How have you heard about ".concat(this.getSiteName(), "?"), "Comment avez vous entendu parler de ".concat(this.getSiteName(), "?"))), /*#__PURE__*/React.createElement("div", {
        className: "checkbox-container custom-control solid-checkbox"
      }, /*#__PURE__*/React.createElement(Form, {
        fields: this.state.checkboxes,
        setParentState: function setParentState(fields) {
          return _this2.setCheckboxes(fields);
        }
      }))), /*#__PURE__*/React.createElement("button", {
        onClick: this.submit,
        className: "btn_all btn-sm btn-outline-secondary submit"
      }, translate('SUBMIT', 'ENVOYER')))))));
    }
  }]);

  return AskInformationsPage;
}(Component);

AskInformationsPage.propTypes = {
  history: PropTypes.object
};
export default AskInformationsPage;